import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { AuthService } from '../services/auth.service';
import { catchError, throwError } from 'rxjs';

/**
 * Context token that allows specific requests to opt-out of the global
 * 401 → logout handling. Helpful for placeholder/optional data fetches
 * that may legitimately respond with 401 during development.
 */
export const SKIP_AUTH_LOGOUT = new HttpContextToken<boolean>(() => false);

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toast = inject(ToastService);
  const auth = inject(AuthService);

  const skipAuthLogout = req.context.get(SKIP_AUTH_LOGOUT);

  return next(req).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          if (skipAuthLogout) {
            console.warn('Skipping auto-logout for request with opt-out flag:', req.url);
            return throwError(() => err);
          }
          auth.clear();
          toast.error('Your session has expired. Please login again.');
          router.navigate(['/auth/login']);
        } else {
          const message = err.error?.message || 'An unexpected error occurred';
          toast.error(message);
        }
      }
      return throwError(() => err);
    })
  );
};


